// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExamDailyScore_wrapper__reogP"};